import images from "./images";

export { images };

export const abouts = [
  {
    id: 1,
    title: "Fitness Website",
    category: "Full-Stack",
    tec: "React Sass ",
    imgUrl: images.work1,
    url: "https://fitnessappv2.netlify.app",
    explanation:
      "A responsive fitness website  with a user-friendly interface for introduction of the services of the Company.",
    github:
      "https://github.com/yucel1993/React-Projects-Advanced/tree/master/FitnessApp",
  },
  {
    id: 2,
    title: "Movie App",
    category: "Full-Stack",
    tec: "React Tailwind Firebase",
    imgUrl: images.work2,
    url: "https://movieappv2.netlify.app",
    explanation: "A movie application  to browse and discover movies.",
    github:
      "https://github.com/yucel1993/React-Projects-Advanced/tree/master/MovieApp",
  },
  // {
  //   id: 3,
  //   title: "Shopping App",
  //   category: "Full-Stack",
  //   tec: "React Tailwind Redux-Toolkit",
  //   imgUrl: images.work5,
  //   url: "https://shoopingappv2.netlify.app",
  //   explanation:
  //     "An e-commerce shopping application created with React, Tailwind CSS, and Redux-Toolkit for state management.",
  //   github:
  //     "https://github.com/yucel1993/React-Projects-Advanced/tree/master/ShoopingApp",
  // },

  {
    id: 4,
    title: "Stock App",
    category: "Full-Stack",
    tec: "React MUI Tremor Redux-Toolkit",
    imgUrl: images.work7,
    url: "https://stockappclone.vercel.app",
    explanation: "A stock management application for stack environment.",
    github:
      "https://github.com/yucel1993/React-Projects-Advanced/tree/master/stockAppClone",
  },

  {
    id: 6,
    title: "Netflix",
    category: "Full-Stack",
    tec: "NextJs Tailwind FireBase",
    imgUrl: images.work9,
    url: "https://netflixappv1-fvrywnywf-yucel1993.vercel.app",
    explanation: "A Netflix clone streaming and browsing movies and TV shows.",
    github:
      "https://github.com/yucel1993/NextJs-Projects/tree/master/Netflixapp",
  },
  {
    id: 7,
    title: "CarBook",
    category: "Full-Stack",
    tec: "TypeScript NextJs Tailwind Clerk",
    imgUrl: images.work10,
    url: "https://carapp-git-master-yucel1993.vercel.app",
    explanation: "An application for managing car-related information.",
    github: "https://github.com/yucel1993/NextJs-Projects/tree/master/carclone",
  },
  {
    id: 8,
    title: "Filmpire",
    category: "Full-Stack",
    tec: "React Redux AlanAI MUI FireBase ContextAPI",
    imgUrl: images.work11,
    url: "https://filmpirebeta.netlify.app",
    explanation:
      "Filmpire is a film-related application in relating to  movie-related activities.",
    github:
      "https://github.com/yucel1993/React-Projects-Advanced/tree/master/filmpire",
  },
  {
    id: 9,
    title: "DevOverflow",
    category: "Full-Stack",
    tec: "NextJs Tailwind Clerk Webhook Mongo",
    imgUrl: images.work12,
    url: "https://stack-overflow-eta.vercel.app",
    explanation: "A platform is aiming to ask and answer technical questions.",
    github: "https://github.com/yucel1993/devOverflow",
  },
  {
    id: 10,
    title: "Voyager",
    category: "Full-Stack",
    tec: "React Mui Redux Context",
    imgUrl: images.work13,
    url: "https://voyagerv2.netlify.app",
    explanation:
      "Voyager is an application for navigation and exploration purposes.",
    github:
      "https://github.com/yucel1993/React-Projects-Advanced/tree/master/voyager",
  },
  {
    id: 11,
    title: "Thread Clone",
    category: "Full-Stack",
    tec: "NextJs Tailwind Clerk Webhook Mongo",
    imgUrl: images.work14,
    url: "https://threadclone-delta.vercel.app",
    explanation:
      "A thread-based platform for discussions and conversation threads.",
    github: "https://github.com/yucel1993/threadClone",
  },
  {
    id: 12,
    title: "TicketMAster Clone",
    category: "Full-Stack",
    tec: "NextJs Tailwind Clerk Webhook MongoDb Uploadthing Stripe",
    imgUrl: images.work15,
    url: "https://evently-chi.vercel.app",
    explanation:
      "Evently is an event management management for organizing and managing events.",
    github: "https://github.com/yucel1993/evently",
  },
  {
    id: 13,
    title: "MediumClone",
    category: "Full-Stack",
    tec: "NextJs Tailwind Clerk Webhook MongoDb Uploadthing",
    imgUrl: images.work16,
    url: "https://questionary-lovat.vercel.app",
    explanation:
      "MediumClone is a application in which individuals can contribute or share their knowloadge with others.",
    github: "https://github.com/yucel1993/questionary",
  },
  {
    id: 14,
    title: "Messenger",
    category: "Full-Stack",
    tec: "NextJs Tailwind NextAuth  Webhook MongoDb Pusher",
    imgUrl: images.work17,
    url: "https://messengerapp-kohl.vercel.app",
    explanation: "Messenger is a whatsup clone application.",
    github: "https://github.com/yucel1993/messengerapp",
  },
  {
    id: 15,
    title: "EBay App",
    category: "Full-Stack",
    tec: "NextJs Tailwind Clerk  Webhook MongoDb ",
    imgUrl: images.work18,
    url: "https://ecommerce-v1-omega.vercel.app",
    explanation:
      "Ecommerce  is a  EBay clone ,in which people can present their product in the system and customers can buy it.",
    github: "https://github.com/yucel1993/ecommerce_v1",
  },
  {
    id: 16,
    title: "Ecommerce App",
    category: "Full-Stack",
    tec: "NextJs Tailwind Clerk  Webhook MongoDb Paypal Stripe ",
    imgUrl: images.work19,
    url: "https://ecommerce-admin-gray-seven.vercel.app",
    explanation:
      "Ecommerce  is a  classic online purchase product platform for the customers.",
    github: "https://github.com/yucel1993/ecommerce_admin",
  },
  {
    id: 17,
    title: "Landing Page 1",
    category: "UI/UX",
    tec: "React Tailwind ",
    imgUrl: images.work3,
    url: "https://react-tailwind12.netlify.app",
    explanation:
      "A modern landing page showcasing UI/UX design using React with Tailwind CSS for styling.",
    github:
      "https://github.com/yucel1993/React-Projects/tree/master/onePage/tailwind",
  },
  {
    id: 18,
    title: "Landing Page 2",
    category: "UI/UX",
    tec: "React Styled Components",
    imgUrl: images.work4,
    url: "https://react-styled12.netlify.app",
    explanation:
      "A stylish landing page designed using React with Styled Components to display UI/UX design capabilities.",
    github:
      "https://github.com/yucel1993/React-Projects/tree/master/onePage/StyledComponent",
  },
  {
    id: 19,
    title: "Phonebook",
    category: "AWS-DevOps",
    tec: "Flask Cloudformation",
    imgUrl: images.work20,
    url: "https://reactdfff-styled12.netlify.app",
    explanation: "Using the AWS resources to create a phonebook application.",
    github:
      "https://githubSDWE.com/yucel1993/React-Projects/tree/master/onePage/StyledComponent",
  },
  {
    id: 20,
    title: "BlogApp",
    category: "AWS-DevOps",
    tec: "Flask EC2 VPC(Public & Private) ClodFront Route53 S3 Bucket Lambda DynamoDB AmazonRDS ALB ASG   ",
    imgUrl: images.work21,
    url: "https://reactdfff-styled12.netlify.app23",
    explanation: "Using the AWS resources to create a Blog  application.",
    github:
      "https://githubSDWE.com/yucel1993/React-Projects/tree/master/onePage/StyledComponent23",
  },
  {
    id: 21,
    title: "Simple todo App",
    category: "AWS-DevOps",
    tec: "NodeJs MongoDb Kubernetes Docker",
    imgUrl: images.kube,
    url: "",
    explanation:
      "Mongo Db Node js based microservice planned to be deployed in Kubernetes.",
    github: "https://github.com/yucel1993/3-Node-mongo-kubernetes-deployment",
  },
  {
    id: 22,
    title: "Phonebook with Microservices",
    category: "AWS-DevOps",
    tec: "Microservice Mysql Kubernetes Docker Helm",
    imgUrl: images.kube,
    url: "",
    explanation: "Microservices added application.",
    github: "https://github.com/yucel1993/k8s-docker-sql-python",
  },
   {
    id: 23,
    title: "Ansible Terraform for M/PERN Application Automation",
    category: "AWS-DevOps",
    tec: "Ansible Terraform PERN ",
    imgUrl: images.work13,
    url: "https://voyagerv2.netlify.app",
    explanation: "Automation of the M/PERN based applications based on the 3 worker nodes and one control node. Live link deployed to free deployment services. Also, ansible galaxy is integrated for docker deployment",
    github: "https://github.com/yucel1993/Ansible-website-postgresql-nodejs-react",
  },
];
